// MUI
import { Stack } from "@mui/material";

// Constants
import { iconsMap } from "@Constants/iconsMap";

type OemDataHeaderIconProps = Readonly<{
	icon: {
		iconName: string;
		styles: object;
	};
}>;
export default function OemDataHeaderIcon(props: OemDataHeaderIconProps) {
	return (
		<>
			{Boolean(props?.icon) && (
				<Stack style={props.icon.styles}>
					<img src={iconsMap?.[props?.icon?.iconName]} alt="icon" />
				</Stack>
			)}
		</>
	);
}
